import createReactComponent from '../createReactComponent';
export default createReactComponent('chevrons-left', 'ChevronsLeft', [["path",{"d":"m12 6-6 6 6 6m6-12-6 6 6 6","key":"svg-0"}]]);